<template>
  <div id="hockey" >
    <div class="pointOut" >必填</div>
    <van-cell-group>
      <van-field
        readonly
        :disabled="isClubRead"
        @click="setPicker('organization')"
        clearable
        v-model="info.organization.name"
        error-message-align="right"
        :error-message="validator.ErrMsg.organization"
        label="现所属会员单位/公司" placeholder="会员单位/公司"
        class="label-win"
        right-icon="arrow-down"
        input-align="right">
      </van-field>
    </van-cell-group>
    <div class="pointOut" >可选</div>
    <van-field
      clearable
      label="所属冰球队"
      v-model="info.team"
      placeholder="球队"
      class="label-win"
      input-align="right">
    </van-field>
    <van-cell-group @click="setPicker('position')" >
      <van-field
        readonly
        v-model="info.position"
        label="场上位置"
        placeholder="选择位置"
        right-icon="arrow-down"
        input-align="right">
      </van-field>
    </van-cell-group>

    <van-cell-group>
      <van-field
        clearable
        v-model="info.jerseyNo"
        label="队服号码"
        placeholder="号码"
        type="number"
        class="label-win"
        input-align="right">
      </van-field>
      <van-field
        readonly
        @click="setPicker('coach')"
        clearable v-model="info.coach.trueName"
        error-message-align="right"
        :error-message="validator.ErrMsg.coach"
        label="现任教练" placeholder="现任教练"
        class="label-win"
        right-icon="arrow-down"
        input-align="right">
      </van-field>

      <van-field
        clearable
        v-model="info.declaredHistoryTeams"
        label="曾经球队"
        placeholder="多个球队以', '分隔"
        class="label-win"
        input-align="right">
      </van-field>
    </van-cell-group>

    <van-cell-group>
      <van-field
        clearable
        v-model="info.declaredHistoryOrgnizations"
        label="之前所属会员单位"
        placeholder="多个单位以', '分隔"
        class="label-win"
        input-align="right">
      </van-field>
    </van-cell-group>

    <div class="textarea" >
      <h5>冰球成绩</h5>
      <textarea
        v-model="info.athletePerformance"
        placeholder="请输入文字内容..."
        name="" id="" cols="20" rows="5">
      </textarea>
    </div>

    <van-button class="btn" v-if="!isRead || isAppend" size="large" @click="routerPush()" >下一步</van-button>
    <van-button class="btn" v-if="isRead && !isAppend" size="large" @click="updatePlayer()" >保存</van-button>

    <!-- popup -->
    <van-popup v-model="show" position="bottom" :overlay="true">
      <van-field
        v-model="searchName"
        :label="searchLabel"
        placeholder="请输入关键字"
        input-align="right">
        <van-button slot="button" size="small" type="default" @click="onSearch">搜索</van-button>
      </van-field>
      <van-picker show-toolbar @confirm="onConfirm" @cancel="onCancel" :value-key="nameType" :columns="columns" ></van-picker>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { getValidMembership } from '@/utils'
import ValidatorUtils from '@/libs/validator'
import { checkPassport } from '@/libs/passport'
import { setRegisterInfo, getRegisterInfo, getMemberType, getMembership } from '@/libs/cookie-storage'
import { getOrganizationList, getCoachList, getMyPlayer, updatePlayer } from '@/api/info'

import { Field, Cell, CellGroup, Picker, Popup, Toast } from 'vant'

Vue.use(Field).use(Cell).use(CellGroup).use(Picker).use(Popup)

export default {
  name: 'hockey',
  data() {
    return {
      show: false,
      searchLabel: '',
      searchName: '',
      columns: [],
      orgList: [],
      coachList: [],
      popType: '',
      nameType: 'name',
      isRead: false,
      isAppend: false,
      isClubRead: false,
      info: {
        organization: { name: ''},
        team: '',
        position: '',
        jerseyNo: '',
        coach: {
          trueName: ''
        },
        declaredHistoryOrgnizations: '',
        declaredHistoryTeams: '',
        athletePerformance: ''
      },
      rules: {
        organization: [{ required: true, message: '必填消息' }]
      },
      reset: '',
      validMemberShip: {}
    }
  },
  computed: {
  },
  created() {
    checkPassport()

    const membership = getMembership()
    const validMemberShip = this.validMemberShip = getValidMembership(membership)

    this.validator = new ValidatorUtils({
      rules: this.rules,
      data: this.info
    })
    const memberType = getMemberType()
    if (!memberType) return
    this.type = memberType.type
    const regInfo = getRegisterInfo()
    // 第一次注册或拒绝后重新提交
    if (regInfo) {
      this.info = Object.assign(this.info, regInfo)
      this.getOrganizationList()
      this.getCoachList()
    }
    // 个人中心修改
    if (memberType.status === 2) {
      this.isRead = true
      this.getMyPlayer()
    }
    if(this.validMemberShip.membership && this.validMemberShip.membership.length > 0) {
      const obj = _.find(this.validMemberShip.membership, function (item) {
        return item.membershipTypeId === memberType.membershipTypeId
      })
      this.isAppend = !obj
      if (this.isAppend) {
        this.isRead = true
      }
    }
//    this.info = regInfo || this.validator.Data
    this.reset = this.$route.query.reset
    const isInValid = moment().isAfter(validMemberShip.membershipBeginDate)
    this.isClubRead = this.isRead && isInValid
  },
  mounted() {},
  methods: {
    setPicker(popType) {
      if (this.isClubRead && popType === 'organization') {
        return
      }
      this.popType = popType
      this.nameType = 'name'
      if (popType === 'organization') {
        this.searchLabel = '搜索会员单位'
        this.columns = this.orgList
      } else if (popType === 'position') {
        this.columns = ['前锋','后卫','守门员']
      } else if (popType === 'coach') {
        this.searchLabel = '搜索教练'
        this.nameType = 'trueName'
        this.columns = this.coachList
      }
      this.show = true
    },
    onSearch() {
      let params = {}
      if (this.popType === 'organization') {
        params.name = this.searchName
        params.status = 0
        params.pageSize = 9999
        getOrganizationList(params).then(response => {
          const data = response.data
          if(data) {
            this.columns = data.list
          }
        })
      } else if (this.popType === 'coach') {
        params.trueName = this.searchName
        getCoachList(params).then(response => {
          const data = response.data
          if(data) {
            this.columns = data.list
          }
        })
      }
    },
    onConfirm(value, index) {
      this.info[this.popType] = value
      this.show = false
    },
    onCancel() {
      this.show = false
      this.searchName = ''
    },
    routerPush() {
      if (!this.info.organization.id) {
        Toast('请填写会员单位')
        return
      }
      this.validator.validate(this.info.organization.id).then((res) => {
        const info = getRegisterInfo() || {}
        const regInfo = Object.assign(info, this.info)
        regInfo.organizationId = this.info.organization.id
        setRegisterInfo(regInfo)
        this.$router.push('contact-hockey')
      }, () => {
        Toast('请填写会员单位信息')
      })
    },
    getOrganizationList() {
      const params = {
        status: 0,
        pageSize: 9999
      }
      getOrganizationList(params).then(response => {
        const data = response.data
        if (data) {
          this.orgList = data.list
          const self = this
          if (this.info.organizationId) {
            var organization = _.find(data.list, function (item) {
              return item.id == self.info.organizationId
            })
            this.info.organization = organization || {}
          }
          if (this.info.organization && this.info.organization.id) {
            var organization = _.find(data.list, function (item) {
              return item.id == self.info.organization.id
            })
            this.info.organization = organization || {}
          }
        } else {
          Toast('会员单位获取失败')
        }
      })
    },
    getCoachList() {
      getCoachList().then(response => {
        const data = response.data
        if(data) {
          this.coachList = data.list
          if (this.info.coachId) {
            const self = this
            var coach = _.find(data.list, function (item) {
              return item.id === self.info.coachId
            })
            if (coach) {
              this.info.coach = coach
            }
          }
        } else {
          Toast('会员单位获取失败')
        }
      })
    },
    getMyPlayer() {
      getMyPlayer().then(response => {
        const data = response.data
        if (data) {
          this.info = Object.assign(this.info, data.player.user, data.player)
          this.mapPickerValues()
        }
      })
    },
    mapPickerValues() {
      this.getOrganizationList()
      this.getCoachList()
    },
    updateInfo() {
      this.updatePlayer()
    },
    updatePlayer() {
      if (!this.info.organization.id) {
        Toast('请填写会员单位')
        return
      }
      const params = {
        id: this.info.id,
        team: this.info.team,
        position: this.info.position,
        jerseyNo: this.info.jerseyNo,
        coachId: this.info.coach.id,
        organizationId: this.info.organization.id,
        declaredHistoryTeams: this.info.declaredHistoryTeams,
        declaredHistoryOrgnizations: this.info.declaredHistoryOrgnizations,
        athletePerformance: this.info.athletePerformance
      }
      updatePlayer(params).then(response => {
        const data = response.data
        if (data) {
          Toast('保存成功')
          if (this.reset==1) {
            this.$router.push({path: 'contact-hockey', query: {reset: 1}})
          } else {
            this.$router.push('ucenter')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
  #hockey {
    height: 100%;
    overflow-y: scroll;
  }

  #hockey .textarea {
    padding: 15px;
    width: calc(100% - 30px);
  }

  #hockey .textarea h5 {
    font-size: 16px;
    padding: 10px 0 20px 0;
    margin: 0;
  }

  #hockey .textarea textarea {
    width: 100%;
    border-radius: 10px;
    font-size: 16px;
    border: none;
  }

  #hockey .pointOut {
    padding: 0 15px;
    height: 40px;
    background-color: rgba(248,248,248,1);
    font-weight:400;
    color:rgba(129,129,129,1);
    line-height: 40px;
  }

  #hockey .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  #hockey .van-hairline--top-bottom::after {
    border-width: 0;
  }

  #hockey .van-cell {
    font-size: 16px;
    padding: 20px 15px;
    border-bottom: 1px solid #F2F2F2;
  }

  #hockey .btn {
    height:60px;
    background: #185494;
    border-radius:2px;
    border: none;
    margin-top: 30px;
    font-weight:400;
    color: white;
    font-size:20px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/hockey.vue